export default "__VITE_ASSET__97824ca4__"